module.exports = __webpack_public_path__ + "media/images/lb/696-40f1fdeaa537269cf5680048eb6845b1.svg";